import { Category } from 'generated/graphql';

export const getChartLabelIdOrName = (label?: string) => {
  if (!label) {
    return '';
  }
  //split after colon only if last part is one of the categories: "ISSUE", "PRAISE", "HELP", "IMPROVEMENT"
  const possibleCategoryValues = Object.values(Category).map((category) =>
    String(category),
  );
  return possibleCategoryValues.includes(label.split(':')?.[1])
    ? label.split(':')[0]
    : label;
};
